module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Age Calculator",
      "icon": "age-calculator"
    }
  }), _vm._v(" "), _c('div', [_c('control', {
    attrs: {
      "for": "deceased_date_of_birth",
      "label": "Date of Birth"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:deceased_date_of_birth.required",
      value: ({
        type: 'date'
      }),
      expression: "{type:'date'}",
      arg: "deceased_date_of_birth",
      modifiers: {
        "required": true
      }
    }],
    ref: "deceasedDateOfBirth",
    on: {
      "change": function($event) {
        return _vm.updateCounter(_vm.totalInputs + 1)
      },
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfBirth),
      callback: function($$v) {
        _vm.dateOfBirth = $$v
      },
      expression: "dateOfBirth"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_date_of_birth')
    }
  }, [_vm._v("\n                        The date of birth is required and must be in the format DD/MM/YYYY\n                    ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "for": "deceased_date_of_death",
      "label": "Date of Death"
    }
  }, [_c('date-input', {
    directives: [{
      name: "field-control",
      rawName: "v-field-control:deceased_date_of_death.required",
      value: ({
        type: 'date',
        rules: _vm.dateOfDeathRules
      }),
      expression: "{type:'date', rules:dateOfDeathRules}",
      arg: "deceased_date_of_death",
      modifiers: {
        "required": true
      }
    }],
    ref: "deceasedDateOfDeath",
    on: {
      "change": function($event) {
        return _vm.updateCounter(_vm.totalInputs + 1)
      },
      "input": _vm.handler
    },
    model: {
      value: (_vm.dateOfDeath),
      callback: function($$v) {
        _vm.dateOfDeath = $$v
      },
      expression: "dateOfDeath"
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('deceased_date_of_death')
    }
  }, [_vm._v("\n                        The date of death is required and must be in the format DD/MM/YYYY\n                    ")])], 1)], 1), _vm._v(" "), _c('h2', {
    staticClass: "u-r-margin-top-40"
  }, [_vm._v("\n                Result\n            ")]), _vm._v(" "), _c('control', {
    attrs: {
      "for": "age_at_death",
      "label": "Age at Death"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.ageAtDeath),
      expression: "ageAtDeath"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "disabled",
      "id": "age_at_death",
      "type": "number",
      "name": "age_at_death"
    },
    domProps: {
      "value": (_vm.ageAtDeath)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ageAtDeath = $event.target.value
      }
    }
  })])], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ageAtDeath),
      expression: "ageAtDeath"
    }],
    staticClass: "flex-grid--vertical",
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("Explanation")]), _vm._v(" "), _c('p', [_vm._v("\n                The age at death calculator has determined the age for a person who was\n                born on " + _vm._s(_vm.dateOfBirth) + " and who died on " + _vm._s(_vm.dateOfDeath) + " as " + _vm._s(_vm.ageAtDeath) + " years old.\n                "), _c('br'), _c('br')]), _vm._v(" "), _c('value-bars', {
    attrs: {
      "values": _vm.barValues
    }
  }, [_c('h3', [_vm._v("Age at Date of Death — " + _vm._s(_vm.dateOfDeath))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar1"
  }, [_c('span')]), _vm._v(" "), _c('h3', [_vm._v("Age at Today's Date — " + _vm._s(_vm.todaysDate))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar2"
  }, [_c('span')])]), _vm._v(" "), _c('p', [_c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("\n                    Perhaps try our\n                    "), _c('router-link', {
    attrs: {
      "to": '/mini-calculators/life-expectancy'
    }
  }, [_vm._v("Life Expectancy Calculator")]), _vm._v("\n                    in order to see how the person's life expectancy compares to the figures provided here.\n                ")], 1)])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-65acd63e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/calculators/ageCalculator.vue
// module id = 1725
// module chunks = 0